document.addEventListener("click", function (e) {
  if (e.target && e.target.id === "ClearCartButton") {
    if (!confirm("Are you sure you want to clear your cart?")) return;

    fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(() => {
      window.location.reload();
    });
  }
});